import { configureStore } from "@reduxjs/toolkit";

import  userSlice  from "./feature/userSlice";
import  commonSlice  from "./feature/manufacturing_app/commonSlice";
import  menuSlice  from "./feature/manufacturing_app/menuSlice";
import commonMasterListSlice from "./feature/manufacturing_app/commonMasterListSlice";
import commonTransactionListSlice from "./feature/manufacturing_app/commonTransactionListSlice";
import operatorReportSlice from "./feature/manufacturing_app/operatorReportSlice";

const store = configureStore({
  reducer: {
    user : userSlice,
    common : commonSlice,
    menu : menuSlice,
    masterList : commonMasterListSlice,
    transactionList : commonTransactionListSlice,
    operatorReport: operatorReportSlice
  }
});

export default store;
